const getArtworkLocationDescription = instance =>
  instance?.currentWarehouseMove?.location?.description || "—";

export default getArtworkLocationDescription;
